/**
 * Converte código numérico ou string do status em rótulo legível.
 *
 * Aceita:
 * - código numérico (0–5)
 * - string numérica ("0"–"5")
 * - rótulo já formatado ("Pendente", "Em Atendimento", etc.)
 *
 * @param {number|string} status
 * @returns {string}
 */
export const getStatusLabelFromCode = (status) => {
  const statusMap = {
    0: "Pendente",
    1: "Em Atendimento",
    2: "Concluída",
    3: "Contato Futuro",
    4: "Perdida",
    5: "Cancelada",
  };

  // Se já veio como texto legível, devolve como está
  if (typeof status === "string" && isNaN(Number(status))) {
    return status;
  }

  const n = typeof status === "string" ? Number(status) : status;
  return statusMap[n] ?? "Desconhecido";
};
